import {
  NewEventMessage,
  EventMessage,
  UpdateEventMessage,
} from "../../models/events";
import { api } from "./api";

export const eventsApi = api.injectEndpoints({
  endpoints: (build) => ({
    newEventMessage: build.mutation<void, NewEventMessage>({
      query: (data) => ({
        url: "/bo/events/message",
        method: "POST",
        body: data,
      }),
    }),
    getEventMessages: build.query<EventMessage[], string | number>({
      query: (id) => ({
        url: `/bo/events/${id}/messages`,
      }),
    }),

    updateEventMessage: build.mutation<void, UpdateEventMessage>({
      query: (data) => ({
        url: "/bo/events/message",
        method: "PATCH",
        body: data,
      }),
    }),

    deleteEventMessage: build.mutation<void, string | number>({
      query: (id) => ({
        url: `/bo/events/message/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useNewEventMessageMutation,
  useGetEventMessagesQuery,
  useUpdateEventMessageMutation,
  useDeleteEventMessageMutation,
} = eventsApi;
